import {
  FormControl,
  Grid,
  Input,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import React, { Ref } from "react";
import { convertDate, convertDateTime } from "../utils/dateConvert";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

const InputWidth = styled(TextField)(({ theme }) => ({
  width: "80%",
}));

type Props = {
  title: string;
  value: any;
  handleEdit: (e: any) => void;
};

export default function InputDateTime({ title, value, handleEdit }: Props) {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography variant="h6" color="black">
            {title}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          <Flatpickr
            render={({ ...props }, ref: Ref<HTMLInputElement>) => {
              return (
                <InputWidth
                  value={convertDateTime({ date: value })}
                  inputRef={ref}
                />
              );
            }}
            value={convertDateTime({ date: value })}
            options={{
              allowInput: true,
              enableTime: true,
              dateFormat: "d/m/Y, H:i",
              time_24hr: true,
            }}
            onChange={(e:any) => {
              handleEdit(e[0]);
            }}
          />
        </Grid>
      </DescGrid>
    </Grid>
  );
}
